import React, { useCallback, useEffect, useState } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import { Spinner } from 'react-bootstrap';

// icons : feather
import FeatherIcon from 'feather-icons-react';

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from 'react-toastify';

// form fields
import AppFormikTextarea from 'utlis/helpers/forms/AppFormikTextarea'

// API
import { addOrderNotes, deleteOrderNotes, getOrderNotes, cancelGetOrderNotesApi } from 'utlis/Apis/SaleOrder_API';

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";

function AddNote(props) {
    // props
    const {
        authState,
        addNoteViewVisibility,
        setAddNoteViewVisibility,

        currentOrderId,

        addedNotesList
    } = props

    // states
    const [orderNotesList, setOrderNotesList] = useState([])

    const [orderLoading, setOrderLoading] = useState(false)
    const [buttonLoading, setButtonLoading] = useState(false)
    const [buttonDisabled, setButtonDisabled] = useState(false)

    // function to get notes
    const getNotes = useCallback((callback = () => { }) => {
        if (currentOrderId) {
            // loading
            setOrderLoading(true)
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // adding note to DB
            getOrderNotes(headers, currentOrderId).then(res => {
                const resData = res.data

                // loading
                setOrderLoading(false)

                // if success
                if (resData?.success) {
                    setOrderNotesList(resData.data)
                }

                // if error
                if (resData?.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    });
                }

                callback() // callback
            }).catch(err => {
                // loading
                setOrderLoading(false)

                console.log(`${ERROR_WHILE__NAME} getOrderNotes`, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                });

                callback() // callback
            })
        }
    }, [authState, currentOrderId])

    // initial form values
    const initialFormValues = {
        note: ""
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        note: Yup.string().required('This field is required'),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // button loading and disable
            setButtonDisabled(true)
            setButtonLoading(true)

            const requiredData = {
                orderId: currentOrderId,
                notes: values.note,
            }

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // adding note to DB
            addOrderNotes(headers, requiredData).then(res => {
                // button loading and disable
                setButtonLoading(false)

                const resData = res.data

                // if success
                if (resData?.success) {
                    // getting latest notes
                    getNotes(() => {
                        // empty formik value
                        formik.setFieldValue('note', "")
                        setAddNoteViewVisibility(false) // hiding add note view
                    })

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success("Note added successfully", {
                        autoClose: 2500,
                        onClose: () => {
                            // button loading and disable
                            setButtonDisabled(false)
                        },
                    });
                }

                // if error
                if (resData?.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500,
                        onClose: () => {
                            // button loading and disable
                            setButtonDisabled(false)
                        },
                    });
                }

            }).catch(err => {
                // button loading and disable
                setButtonDisabled(false)
                setButtonLoading(false)

                console.log(`${ERROR_WHILE__NAME} addOrderNotes`, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                });
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // getting notes
    useEffect(() => {
        if (addedNotesList?.length) {
            setOrderNotesList(addedNotesList)
        }
    }, [addedNotesList])

    // delete note
    const handleDeleteNote = (ev, noteId) => {
        ev.preventDefault()

        if (currentOrderId && noteId) {
            const confirm = window.confirm("Are you sure you want to delete the note?")

            if (confirm) {
                // loading
                setOrderLoading(true)

                const requiredData = {
                    orderId: currentOrderId,
                    noteId
                }

                const headers = {
                    "Authorization": `Bearer ${authState.commonToken}`,
                    "Api-Token": authState.apiToken,
                    "Access-Token": "",
                    // "Store-Id": authState.storeId,
                }
                // delete note from DB
                deleteOrderNotes(headers, requiredData).then(res => {
                    const resData = res.data

                    // loading
                    setOrderLoading(false)

                    // if success
                    if (resData?.success) {
                        const updatesNotesList = orderNotesList.filter(item => item.notes_id !== noteId)

                        setOrderNotesList(updatesNotesList) // setting notes list

                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.success("Note deleted successfully", {
                            autoClose: 2500
                        });
                    }

                    // if error
                    if (resData?.error) {
                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                            autoClose: 2500
                        });
                    }

                }).catch(err => {
                    // loading
                    setOrderLoading(false)

                    console.log(`${ERROR_WHILE__NAME} getOrderNotes`, err.message);

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    });
                })
            }

        }
    }

    // edit note
    const handleEditNote = (ev, noteId) => {
        ev.preventDefault()

        if (currentOrderId && noteId) {

        }
    }


    return (
        // page border box
        <div className="page-border-box mb-4">
            <div className="pbb-inner position-relative">
                <p className="head st-fw-600 st-text-color2 st-fs-16 mb-2">All Notes</p>
                {
                    orderNotesList?.length ? (
                        <div className="existing-notes-container pb-1">
                            {
                                orderNotesList.map(item => (
                                    <div key={item.notes_id} className="note-item mb-2">
                                        <div className="inner d-flex">
                                            <p className="st-text-color pe-2">
                                                <span className="st-fw-600 st-fs-15 st-text-color">{item.notes}</span>
                                                <span className="d-block text-black-50">{item.notes_date}</span>
                                            </p>
                                            {/* <a href="/" className="st-fs-13 text-danger hover-underline-link mt-1">Delete Note</a> */}

                                            <div className="delete d-flex ms-auto">
                                                {/* <span
                                                    className="st-round-btn st-btn-xs st-btn-white d-flex align-items-center justify-content-center me-1"
                                                    title="Edit Note"
                                                    onClick={ev => handleEditNote(ev, item.notes_id)}>
                                                    <FeatherIcon
                                                        icon="edit-2"
                                                        size="14"
                                                        className="icon position-relative" />
                                                </span> */}

                                                <span
                                                    className="st-round-btn st-btn-xs st-btn-white d-flex align-items-center justify-content-center"
                                                    title="Delete Note"
                                                    onClick={ev => handleDeleteNote(ev, item.notes_id)}>
                                                    <FeatherIcon
                                                        icon="trash"
                                                        size="14"
                                                        className="icon position-relative" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    ) : (
                        <p className="mb-3 text-black-50">No note(s) added yet</p>
                    )
                }
                {
                    addNoteViewVisibility ? (
                        <div className="form-container">
                            <form
                                onSubmit={formik.handleSubmit}
                                noValidate
                                autoComplete="off">
                                {/* form field */}
                                <AppFormikTextarea
                                    formik={formik} // formik object
                                    stFormClass={"mb-0"} // class name for main wrapper
                                    labelName={"Note for staff"} // label name
                                    placeholder={"Note for staff"} // placeholder for the input
                                    textareaRows={"2"} // rows for textarea
                                    formikFieldName={"note"} // important: formik value name for the input
                                />
                                <p className="desc d-flex align-items-center st-fs-13 mt-1 mb-3">
                                    <FeatherIcon
                                        icon="lock"
                                        size="13"
                                        className="icon me-2"
                                    />
                                    <span>Notes are not visible to customers.</span>
                                </p>

                                <div className="btns">
                                    <button
                                        className={`st-btn st-btn st-btn-primary me-3 ${buttonDisabled ? "disabled" : ""}`}
                                        disabled={buttonDisabled}>
                                        {
                                            buttonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Submit</span>
                                            )
                                        }
                                    </button>
                                    <button
                                        className={`st-btn ${buttonDisabled ? "disabled" : ""}`}
                                        disabled={buttonDisabled}
                                        onClick={ev => {
                                            ev.preventDefault()

                                            setAddNoteViewVisibility(false)
                                        }}>Cancel</button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <a
                            href="/"
                            className={`d-flex align-items-center st-text-primary hover-underline-link`}
                            onClick={ev => {
                                ev.preventDefault()

                                setAddNoteViewVisibility(true)
                            }}>
                            <FeatherIcon
                                icon="plus"
                                size="16"
                                className="icon me-1"
                            />
                            <span>Add Note</span>
                        </a>
                    )
                }

                {
                    orderLoading ? (
                        <div
                            className="position-absolute h-100 w-100 d-flex align-items-center justify-content-center"
                            style={{ top: 0, left: 0, backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
                            <Spinner animation="border" />
                        </div>
                    ) : null
                }
            </div>
        </div>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(AddNote)